module.exports = __webpack_public_path__ + "static/media/assignto.c388343d.svg";